import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'YagiChatBotAiResultBubble',
  props: {
    text: null,
    active: { type: Boolean }
  },
  emits: ["accept", "regenerate", "edit"],
  setup(__props: any) {





return { __sfc: true, }
}

})